import { Component, OnInit, ElementRef } from '@angular/core';
import { FlashMessagesService } from 'angular2-flash-messages';
import {AuthenticationService} from '../../services/authentication.service';
import {ValidateService} from '../../services/validate.service';

declare var jquery:any;
declare var $ :any;

import {GetdataService} from '../../services/getdata.service';
import {DeletedataService} from '../../services/deletedata.service';
import {AdddataService} from '../../services/adddata.service';
import {RouterModule,ActivatedRoute, Routes, Router} from '@angular/router';

import {Http, Response, Headers} from '@angular/http';
import { SetdataService } from '../../services/setdata.service';
@Component({
  selector: 'app-edit-accounts',
  templateUrl: './edit-accounts.component.html',
  styleUrls: ['./edit-accounts.component.css']
})
export class EditAccountsComponent implements OnInit {
  user:Object;
  accounts:Accounts[];
  meetingrooms:MeetingRooms[];
  workgroups:WorkGroups[];
  public submitted:boolean;

  account_id;
  account_data;

  editaccountname;
  editnumberofrooms;

  constructor(private validateService:ValidateService,private router:Router ,private setDataService:SetdataService , private authService:AuthenticationService,  private route: ActivatedRoute,private _flashMessagesService: FlashMessagesService,private getdataService:GetdataService,  private deletedataService:DeletedataService, private adddataService:AdddataService, private http:Http, private elem: ElementRef) { }

  ngOnInit() {
    this.refreshEverything();
  }
  refreshEverything = ()=>{

    this.account_id = this.route.snapshot.paramMap.get('id');  

    this.getdataService.getAccountNameById(this.account_id).subscribe((accountData) => {
      //console.log(accountData)
      this.account_data = accountData[0];
      console.log(this.account_data);
      this.editaccountname =  this.account_data.account_name;
      this.editnumberofrooms = this.account_data.licensed_rooms;
    },
    err=>{
      //////console.log(err);
      return false;
    });
    

  }

  setAccount = () =>{
    let formData = new FormData();
    formData.append('account_id',this.account_id)
    formData.append('account_name',this.editaccountname);
    formData.append('licensed_rooms',this.editnumberofrooms);
    this.setDataService.setAccountData(formData).subscribe
    (res =>{
          this._flashMessagesService.show('Success: Account edited successfully', {cssClass: 'center-align flow-text card-title z-depth-2 white-text green darken-3', timeout:5000});

          ////////refresh category /////////////
       
               this.submitted=false;
               this.router.navigate(['/admin/accounts']);
        //////////end refresh category.////////

    } );
  }

  // addAccount =function () {
  //   this.submitted=true;
  //   let accoutnname = this.elem.nativeElement.querySelector('#accoutnname').value;
  //   let number_of_rooms_for_this_account = this.elem.nativeElement.querySelector('#number_of_rooms_for_this_account').value;
  //   let feature_outlook =  this.elem.nativeElement.querySelector("#features_checkboxes_outlook").checked ;
  //   let feature_google_calendar =  this.elem.nativeElement.querySelector("#features_checkboxes_googlecalendar").checked ;
  //   let feature_client_portal =  this.elem.nativeElement.querySelector("#features_checkboxes_portal").checked ;

  //   //console.log(feature_outlook)
  //   const account = {
  //     account_name: accoutnname,
  //     licensed_rooms: number_of_rooms_for_this_account,
  //     feature_outlook: feature_outlook,
  //     feature_google_calendar: feature_google_calendar,
  //     feature_client_portal: feature_client_portal
  //   }
  //   ////console.log("this could be a duplicate?");


  //         ////console.log("no duplicate");
  //         this.adddataService.addAccount(account).subscribe(data =>{

  //             alert('Account Added');
  //               this.submitted=false;

  //         });

  //       this.refreshEverything();
  //   }

}
interface Accounts{
  _id:number,
  account_name:string,
  licensed_rooms:number
}

interface MeetingRooms{
  _id:number,
  room_name:string,
  room_place:string,
  room_default_logo:string,
  room_default_logo_path:string,
  room_type:string,
  room_floor_number:string,
  room_slider_ID:string
}

interface WorkGroups{
  _id:number,
  account_ID:string,
  workgroup_name:string
}



// WEBPACK FOOTER //
// ./src/app/components/edit-accounts/edit-accounts.component.ts